import React, { useContext } from "react";
import LanguageContext from "../../../utils/Contexts/LanguageContext";

function AffiliationSection({ domain }) {
  const { t } = useContext(LanguageContext);

  return (
    <div id="affiliationSection" className="card card-setting">
      <div className="card-header">
        <h2 className="card-title h4">{t("Affiliation")}</h2>
      </div>

      <div className="card-body">
        <p className="responsive-text">
          {t(
            "Before advertising your websites to the clients we need to verify you ability to post on"
          )}{" "}
          <a
            className="text-primary text-decoration-underline responsive-text"
            href={domain}
            rel="noreferrer"
            target="_blank"
          >
            {domain}
          </a>{" "}
          {t("domain")}
          <p className="responsive-text">
            {" "}
            {t(
              "There are two way how we can verify you affiliation to the site:"
            )}{" "}
          </p>
        </p>
        <div className="affiliation-lg d-md-flex justify-content-between gap-2">
          <div className="border w-50 rounded-top">
            <div className="p-3">
              <h5 className="card-title">{t("Ownership Verification")}</h5>
              <p className="responsive-paragraph text-secondary">
                {t(
                  "You have two choices for verifying your website: either download a"
                )}{" "}
                {/* eslint-disable-next-line */}
                <a href="javascript:;"
                  className="text-primary text-decoration-underline responsive-paragraph"
                >
                  {t("file")}
                </a>{" "}
                {t("and place it in the root directory, or insert")}{" "}
                <span className="text-dark responsive-paragraph">
                  954d2c2e-60db-4be4-b46b-4c4878bac7d8
                </span>{" "}
                {t("code into the source code of your website's main page.")}
              </p>
            </div>
          </div>

          <div className="border rounded-top w-50">
            <div className="p-3">
              <h5 className="card-title">{t("Contribution Verification")}</h5>
              <p className="responsive-paragraph text-secondary">
                {t(
                  "In order to confirm your capability to create, add, and publish content on a website, we request that you publish a"
                )}{" "}
                <a href={domain} target="_blank" rel="noreferrer">
                  {t("Test Post")}
                </a>{" "}
                {t("on the")}{" "}
                <a
                  href={domain}
                  target="_blank"
                  rel="noreferrer"
                  className="text-primary text-decoration-underline"
                >
                  {domain}
                </a>{" "}
                {t("domain")}.
              </p>
            </div>
          </div>
        </div>

        <div className="affiliation-lg d-md-flex justify-content-between gap-2">
          <div className="w-50 border border-top-0">
            <div className="m-2 py-3 bg-soft-secondary rounded me-lg-2 mb-3 mb-lg-0">
              <div className="px-3 d-flex justify-content-between mb-1 text-dark">
                <p
                  className="responsive-text-affiliation"
                  style={{ margin: "unset" }}
                >
                  {t("File")}
                </p>
                <p
                  className="bg-soft-danger text-danger py-1 rounded-1 text-center"
                  style={{ margin: "unset", width: "89px" }}
                >
                  {t("Not Found")}
                </p>
              </div>
              <div className="px-3 d-flex justify-content-between text-dark">
                <p
                  className="responsive-text-affiliation"
                  style={{ margin: "unset" }}
                >
                  {t("Source Code")}
                </p>
                <p
                  className="bg-soft-danger text-danger py-1 rounded-1  text-center"
                  style={{ margin: "unset", width: "89px" }}
                >
                  {t("Not Found")}
                </p>
              </div>
            </div>
          </div>

          <div className="w-50 border border-top-0">
            <div className="m-2 pt-3 pb-1 bg-soft-secondary rounded">
              <div className="px-3 d-flex justify-content-between text-dark">
                <p className="responsive-text-affiliation">
                  {t("Test Post Request")}
                </p>
                <button className="btn btn-danger d-flex justify-content-center align-items-center recall-btn">
                  {t("Recall")}
                </button>
              </div>
              <p className="px-3 responsive-paragraph text-secondary ">
                {t(
                  "We are currently in the process of creating a test post content. Once the content is ready, we will notify you and create a task for you."
                )}
              </p>
              <p className="px-3 text-secondary small-txt">
                {t("Request Changed 8s ago.")}
              </p>
            </div>
          </div>
        </div>

        <div className="affiliation-lg d-md-flex justify-content-between gap-2">
          <div className="w-50 border border-top-0 rounded-bottom d-flex">
            <div className="p-3 align-self-end">
              <button
                className="btn btn-outline-primary btn-verify d-flex align-items-center justify-content-center"
                style={{
                  whiteSpace: "nowrap",
                }}
              >
                {t("Verify")}
              </button>
            </div>
          </div>

          <div className="w-50 border border-top-0 rounded-bottom">
            <div className="p-3 d-flex gap-3">
              <div className="align-self-end">
                <button
                  className="btn btn-outline-secondary "
                  style={{
                    padding: "0.5rem 0.7rem",
                    whiteSpace: "nowrap",
                    borderColor: "#1f2123",
                    fontSize: "14px",
                    fontWeight: "600",
                  }}
                >
                  {t("Request a Test Post")}
                </button>
              </div>
              <div
                className="text-secondary"
                style={{ fontSize: "12px", fontWeight:"400" }}
              >
                <span className="text-dark">{t("Note")}: </span>
                {t(
                  "this task will not be paid and has to be requested by those who wanted to has more competitive Rating and low (not empty) websites Turn Around Time"
                )}
              </div>
            </div>
          </div>
        </div>

        {/* for small screen to match design */}
        <div className="affiliation-md border me-lg-2 mb-3 mb-lg-0 rounded w-100">
          <div className="p-3">
            <h5 className="card-title">{t("Ownership Verification")}</h5>
            <p className="responsive-paragraph">
              {t(
                "You have two choices for verifying your website: either download a"
              )}{" "}
              {/* eslint-disable-next-line */}
              <a href="javascript:;"
                className="text-primary text-decoration-underline"
              >
                {t("file")}
              </a>{" "}
              {t("and place it in the root directory, or insert")}{" "}
              <span className="text-body">
                954d2c2e-60db-4be4-b46b-4c4878bac7d8
              </span>{" "}
              {t("code into the source code of your website's main page.")}
            </p>
          </div>
          <hr style={{ width: "100%", margin: "4px 0px" }} />
          <div className="p-1">
            <div className="my-1 mx-2 pt-3 bg-soft-secondary rounded-3">
              <div className="responsive-text px-3 d-flex justify-content-between text-dark">
                <p className="responsive-text-affiliation">{t("File")}</p>
                <p
                  className="bg-soft-danger text-danger py-1 rounded text-center"
                  style={{ width: "89px" }}
                >
                  {t("Not Found")}
                </p>
              </div>
              <div className="responsive-text px-3 d-flex justify-content-between text-dark">
                <p className="responsive-text-affiliation">
                  {t("Source Code")}
                </p>
                <p
                  className="bg-soft-danger text-danger py-1 rounded text-center"
                  style={{ width: "89px" }}
                >
                  {t("Not Found")}
                </p>
              </div>
            </div>
          </div>
          <hr style={{ width: "100%", margin: "4px 0px" }} />
          <div className="d-flex justify-content-between px-3 py-2">
            <button className="btn btn-outline-primary btn-verify d-flex align-items-center justify-content-center">
              {t("Verify")}
            </button>
          </div>
        </div>

        <div className="affiliation-md border me-lg-2 mb-3 mb-lg-0 rounded w-100">
          <div className="p-3">
            <h5 className="card-title">{t("Contribution Verification")}</h5>
            <p className="text-secondary responsive-paragraph">
              {t(
                "In order to confirm your capability to create, add, and publish content on a website, we request that you publish a"
              )}{" "}
              <a href={domain}>{t("Test Post")}</a> {t("on the")}{" "}
              <strong>{domain}</strong> {t("domain")}.
            </p>
          </div>
          <hr style={{ width: "100%", margin: "2px 0px" }} />

          <div className="p-1">
            <div className="m-2 px-3 py-3 bg-soft-secondary rounded-3">
              <div className="d-flex justify-content-between text-dark ">
                <p className="responsive-text-affiliation">
                  {t("Test Post Request")}
                </p>
              </div>
              <p className="text-secondary responsive-paragraph">
                {t(
                  "We are currently in the process of creating a test post content. Once the content is ready, we will notify you and create a task for you."
                )}
              </p>
              <p className="small-txt text-secondary">
                {t("Request Changed 8s ago.")}
              </p>
              <button className="btn btn-danger d-flex justify-content-center align-items-center recall-btn">
                {t("Recall")}
              </button>
            </div>
          </div>

          <hr style={{ width: "100%", margin: "2px 0px" }} />
          <div className="d-flex flex-wrap-reverse justify-content-between p-3 gap-3">
            <button
              className="btn btn-outline-secondary "
              style={{
                lineHeight: "1",
                height: "auto",
                padding: "0.5rem 0.5rem",
                whiteSpace: "nowrap",
                borderColor: "#1f2123",
                fontSize: "14px",
                fontWeight: "600",
              }}
            >
              {t("Request a Test Post")}
            </button>
            <div className="text-secondary" style={{ fontSize: "12px", fontWeight:"400" }}>
              <span className="text-dark">{t("Note")}: </span>{" "}
              {t(
                "this task will not be paid and has to be requested by those who wanted to has more competitive Rating and low (not empty) websites Turn Around Time"
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AffiliationSection;
